// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var Options = {};

var Plugins = {};

function useCurrentIndex(api, startIdxOpt) {
  var startIdx = startIdxOpt !== undefined ? startIdxOpt : 0;
  var match = React.useState(function () {
        return startIdx;
      });
  var setCurrentIdx = match[1];
  var updateCurrentIdx = React.useCallback((function (api) {
          var idx = api.selectedScrollSnap();
          setCurrentIdx(function (param) {
                return idx;
              });
        }), [
        api,
        setCurrentIdx
      ]);
  React.useEffect((function () {
          if (api !== undefined) {
            var api$p = Caml_option.valFromOption(api);
            api$p.on("reInit", updateCurrentIdx);
            api$p.on("select", updateCurrentIdx);
          }
          return (function () {
                    if (api === undefined) {
                      return ;
                    }
                    var api$p = Caml_option.valFromOption(api);
                    api$p.off("reInit", updateCurrentIdx);
                    api$p.off("select", updateCurrentIdx);
                  });
        }), [
        api,
        setCurrentIdx,
        updateCurrentIdx
      ]);
  return match[0];
}

function useButtonStatus(api) {
  var match = React.useState(function () {
        return false;
      });
  var setCanGoPrev = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var setCanGoNext = match$1[1];
  var updateButtonStatus = React.useCallback((function (api) {
          setCanGoPrev(function (param) {
                return api.canScrollPrev();
              });
          setCanGoNext(function (param) {
                return api.canScrollNext();
              });
        }), [
        setCanGoNext,
        setCanGoPrev,
        api
      ]);
  React.useEffect((function () {
          if (api !== undefined) {
            Caml_option.valFromOption(api).on("slidesInView", updateButtonStatus);
          }
          return (function () {
                    if (api !== undefined) {
                      Caml_option.valFromOption(api).off("slidesInView", updateButtonStatus);
                      return ;
                    }
                    
                  });
        }), [
        api,
        setCanGoPrev,
        setCanGoNext
      ]);
  return [
          match[0],
          match$1[0]
        ];
}

export {
  Options ,
  Plugins ,
  useCurrentIndex ,
  useButtonStatus ,
}
/* react Not a pure module */
